/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-09-17 16:07:51
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-09-19 17:05:34
 * @FilePath: /miaobi-app-h5/src/router/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: () => import('../views/Home.vue'),
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('../views/About.vue'),
  // },
  {
    path: '/lesson-info',
    name: 'LessonInfo',
    component: () => import('../views/LessonInfo/index.vue'),
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import('../views/Download/index.vue'),
    meta: {
      title: '作品下载',
    },
  },
  {
    path: '/musicIsolate',
    name: 'MusicIsolate',
    component: () => import('../views/MusicIsolate/index.vue'),
    meta: {
      title: '音轨分离',
    },
  },
  {
    path: '/pictureBook',
    name: 'PictureBook',
    component: () => import('../views/PictureBook.vue'),
    meta: {
      title: '妙笔AI绘本',
    },
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../views/Detail.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/work-list',
    name: 'workList',
    component: () => import('../views/WorkList.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/pdf-portfolio',
    name: 'pdfPortfolio',
    component: () => import('../views/PdfPortfolio.vue'),
    meta: {
      title: 'PDF 作品集',
    },
  },
  {
    path: '/model-3d',
    name: 'model3d',
    component: () => import('../views/ModelViewer3d.vue'),
    meta: {
      title: '3D 模型',
    },
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/help/index.vue'),
    meta: {
      title: '帮助中心',
    },
  },
  {
    path: '/help/list',
    name: 'helpList',
    component: () => import('../views/help/list.vue'),
    meta: {
      title: '问题列表',
    },
  },
  {
    path: '/help/detail',
    name: 'helpDetail',
    component: () => import('../views/help/detail.vue'),
    meta: {
      title: '问题详情',
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
// 全局导航守卫设置标题
router.beforeEach((to, from, next) => {
  // 如果路由配置了标题，则设置页面标题
  if (to.meta.title && typeof to.meta.title === 'string') {
    document.title = to.meta.title;
  }
  next();
});

export default router;
